<template>
  <div class="one-photo">
    <p class="photo-title">{{title}}</p>
    <div class="photo_box" v-if="!imgData.endsWith('.pdf')">
      <el-upload
        v-show="!isShowImg"
        id="fileUploadId0"
        action=""
        accept=".jpg,.jpeg,.png,.pdf"
        :show-file-list="false"
        :http-request="(e) => uploadImgSuccess(e, 'simple')"
        :before-upload="beforeImgUpload"
      >
        <div class="photo-content h5-top">
            <p><img src="@/assets/pc/upload-outline@2x.png" />Upload Photo</p>
        </div>
      </el-upload>
      <img class="img" :src="imgData" v-if="isShowImg && !imgData.endsWith('.pdf')">
    </div>
    <div class="file" @click="openFile(imgData)" v-if="isShowImg && imgData.endsWith('.pdf')">
        <img class="success-icon" src="@/assets/pc/success-filled.png" />
        <span>{{ getFileName(imgData) }}</span>
        <img class="close-icon" src="@/assets/pc/file-cancel-icon.png" @click.stop="remove" />
    </div>
    <div class="photo-btn" @click="uploadClick" v-if="isShowImg && !imgData.endsWith('.pdf')">
        <img src="@/assets/pc/upload-outline@2x.png" />
        <span>Replace Photo</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "OnePhotoUpload",
    components: {},
    props: {
      img:{
        type: String,
        default: ""
      },
      title:{
        type: String,
        default: ""
      }
    },
    created() {
      this.imgData = this.img
    },
    data() {
      return {
        imgData: '',
        showDialog: false,
        uploadingNumber: 0,
      }
    },
    computed: {
      // 判断展示图片还是空白
      isShowImg() {
        return this.imgData !== ""
      }
    },
    methods: {
      // 删除图片
      remove() {
        this.imgData = ""
      },
      showPdf() {
        this.showDialog = true;
      },
      closeDialog() {
        this.showDialog = false;
      },
      // 自动触发上传
      uploadClick() {
        const element2 = document.querySelector(`#fileUploadId0 .el-upload__input`);
        element2 && element2.click();
      }
    },
    watch: {
      imgData:function(val) {
        this.$emit("uploadData", val)
      },
      img:function(val) {
        this.imgData = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .one-photo {
    margin-right: 20px;
    & > div {
      font-size: 0;
    }
    .photo-title {
      font: normal normal normal 16px/24px Nunito;
      margin-bottom: 4px;
    }
    .photo_box {
      width: 366px;
      height: 216px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      overflow: hidden;
      margin-top: 10px;
      & > div {
        text-align: center;
      }
      .photo-content {
        width: 366px;
        height: 216px;
        border-radius: 8px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        background-color: #E5F5FF;
        img {
            width: 302px;
            height: 193px;
        }
        p {
          margin: 0 auto;
          width: 195px;
          color: #0072D8;
          font: normal normal normal 16px/48px Nunito-bold;
          border-radius: 8px;
          border: 2px solid #0072D8;
          text-align: left;
          padding-left: 24px;
          box-sizing: border-box;
          img {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: -5px;
          }
        }
      }
      // .bottom-tip {
      //   margin: 5px auto;
      //   width: 100%;
      //   color: #0072D8;
      //   font: normal normal normal 16px/24px Nunito-bold;
      //   display: flex;
      //   align-items: center;
      //   justify-content: flex-end;
      //   img {
      //       width: 18px;
      //       height: 18px;
      //       vertical-align: middle;
      //       margin-right: 8px;
      //   }
      // }
    }
    .img {
      width: 366px;
      height: 216px;
      border-radius: 8px;
      display: block;
    }
    .file {
      width: 100%;
      display: flex;
      font: normal normal normal 14px/24px Nunito-bold;
      background-color: #F6F6F6;
      padding: 12px 16px 12px 12px;
      align-items: center;
      color: #2E2E2E;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      word-break: break-word;
      margin-top: 8px;
      .success-icon {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      span {
        flex: 1;
      }
      .close-icon {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
    }
    .photo-btn {
      width: 366px;
      padding-top: 10px;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        margin-top: -2px;
      }
      span {
        font: normal normal normal 16px/22px Nunito;
        color: #0072D8;
        cursor: pointer;
      }
    }
  }
</style>